import { useAuth } from 'context/auth-context';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TokenExpiredError = () => {
  const { isLoading, isTokenExpired, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const previousPath = location.state?.from || '/home';

  // After refresh completes successfully, redirect back to original route
  useEffect(() => {
    if (!isLoading && isAuthenticated && !isTokenExpired) {
      navigate(previousPath, { replace: true });
    }
  }, [isLoading, isAuthenticated, isTokenExpired, navigate, previousPath]);

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-2xl font-bold mb-4">Session Expired</h1>
      <p className="text-gray-600 mb-8">
        Your session has expired. Refreshing...
      </p>
      {isLoading && (
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      )}
    </div>
  );
};

export default TokenExpiredError;
